// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___pQYDf";
var _2 = "styles-module__img___Z37vq";
var _3 = "styles-module__opacCover___W32RU";
var _4 = "styles-module__title___Y6ysD";
export { _1 as "container", _2 as "img", _3 as "opacCover", _4 as "title" }
